import React from "react";
import NavbarSearch from "./NavbarSearch";
import { BellIcon, BookmarkIcon, FolderOpenIcon } from "./NavbarIcons";

function MobileNavbar({
  navigate,
  t,
  isBookDetailPage,
  isMessagesPage,
  isLoggedIn,
  query,
  handleSearchChange,
  searchContainerRef,
  isSearching,
  showResults,
  searchResults,
  currentLang,
  unreadCount,
  handleNotificationsClick,
  openAuthPrompt,
  openMenuModal,
}) {
  return (
    <>
      {/* Мобильная нижняя панель */}
      {!(isBookDetailPage || isMessagesPage) && (
        <NavbarSearch
          variant="mobile"
          navigate={navigate}
          t={t}
          searchContainerRef={searchContainerRef}
          query={query}
          handleSearchChange={handleSearchChange}
          isSearching={isSearching}
          showResults={showResults}
          searchResults={searchResults}
          currentLang={currentLang}
        />
      )}

      <div className="desktop:hidden fixed bottom-0 left-0 w-full bg-[#191A1C] z-50 border-t border-gray-700">
        <ul className="flex justify-around items-center py-2 text-white text-sm">
          <li
            onClick={() => (isLoggedIn ? navigate("/bookmarks") : openAuthPrompt())}
            className="flex flex-col items-center hover:cursor-pointer"
          >
            <BookmarkIcon className="text-[#AAA] w-5 h-5" />
            <span>{t("bookmarks")}</span>
          </li>
          <li
            onClick={() => navigate("/catalog")}
            className="flex flex-col items-center hover:cursor-pointer"
          >
            <FolderOpenIcon className="text-[#AAA] w-5 h-5" />
            <span>{t("catalog")}</span>
          </li>
          <li onClick={() => navigate("/")} className="flex flex-col items-center hover:cursor-pointer">
                <img
                    src="/logomark-white.svg"
                    className="w-8 h-9"
                    width="32"
                    height="36"
                    alt=""
                />
          </li>
          <li
            onClick={() => (isLoggedIn ? handleNotificationsClick() : openAuthPrompt())}
            className="relative flex flex-col items-center hover:cursor-pointer"
          >
            <BellIcon className="text-[#AAA] w-5 h-5" />
            {unreadCount > 0 && (
              <span className="absolute top-0 right-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] leading-none text-white">
                {unreadCount}
              </span>
            )}
            <span>{t("notifications")}</span>
          </li>
          <li className="flex flex-col items-center hover:cursor-pointer" onClick={openMenuModal}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16m-16 6h16" className="text-[#AAA]" />
            </svg>
            <span>{t("menu")}</span>
          </li>
        </ul>
      </div>
    </>
  );
}

export default MobileNavbar;
